import React from 'react';
import styled from 'styled-components';
import { NavLink } from 'react-router-dom';

type GisMenuItem = {
  label: string;
  to: string;
};

const gisMenuItems: GisMenuItem[] = [
  { label: 'GIS Service', to: '.' },
  { label: 'GIS FAQ', to: 'gis_faq' },
  { label: 'GIS Policies and Procedures', to: 'gis_policy' },
  { label: 'Guide Specifications', to: 'guide_specifications' },
  { label: 'Specify the GIS', to: 'gis_wording' },
  { label: 'GIS Fees', to: 'gis_fees' },
  { label: 'Manufacturer Templates', to: 'gis_for_manufacturers' },
];

const Wrapper = styled.nav`
  margin: 24px 0 36px;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: flex-start;
`;

const Tab = styled(NavLink)`
  padding: 10px 16px;
  border-radius: 10px;

  font-size: 14px;
  font-weight: 700;
  line-height: 1.2;

  text-decoration: none;
  white-space: nowrap;

  color: #0b1220;
  border: 2px solid rgba(11, 18, 32, 0.15);
  background: transparent;

  transition: 
    background-color 160ms ease,
    color 160ms ease,
    border-color 160ms ease,
    transform 120ms ease;

  &:hover {
    transform: translateY(-1px);
    border-color: #b1002a;
    color: #b1002a;
  }

  &.active {
    background: #b1002a;
    color: #ffffff;
    border-color: #b1002a;
  }
`;
export const GisSubMenu: React.FC = () => (
        <Wrapper>
            {gisMenuItems.map((item) => (
                <Tab
                    key={item.to}
                    to={item.to}
                    end={item.to === '/gis' || item.to === '.'}
                >
                    {item.label}
                </Tab>
            ))}
        </Wrapper>
);
